import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { res } from '../../../common/language/text/res';
import { Strings } from '../../../common/language/strings';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { CatalogDetInfo } from '../../../common/model/dictionary/CatalogDetInfo';
import { Organization } from '../../../common/model/Organization';
import { CatalogDet } from '../../../common/model/CatalogDet';
import { PriceLabelSection } from '../../../common/model/PriceLabelSection';
import { PriceLabelSectionFacade } from '../../../common/facade/PriceLabelSectionFacade';
import { PriceLabelFacade } from '../../../common/facade/PriceLabelFacade';
import { PriceLabel } from '../../../common/model/PriceLabel';
import { PriceLabelDet } from '../../../common/model/PriceLabelDet';
import { Router } from '@angular/router';
import { CatalogInfo } from '../../../common/model/dictionary/CatalogInfo';


@Component({
  selector: 'app-price-label',
  templateUrl: './price-label.component.html',
  styleUrls: ['./price-label.component.css']
})
export class PriceLabelComponent implements OnInit {

  // Loading
  public loading = false;
  public messageLoader = '';

  // alert
  public alerts = [];

  // String Resources
  public res = res;

  isSpanish = true;
  language: number = 0;
  tenantId = -1;
  lsOrganization: Organization[] = [];
  lsPriceType: CatalogDet[] = [];
  cmb_PriceLabelSectionA1 = -1;
  cmb_PriceLabelSectionA2 = -1;
  cmb_PriceLabelSectionB1 = -1;
  cmb_organization = '-1';
  cmb_priceType = -1;
  cmb_barcodeType: number = -1;
  barcodeExample: string;
  isBasePrice: boolean = false;
  aditionalRow: boolean = false;
  percentDiscount: boolean = false;
  lsPriceLabelSectionA1: PriceLabelSection[] = [];
  lsPriceLabelSectionA2: PriceLabelSection[] = [];
  lsPriceLabelSectionB1: PriceLabelSection[] = [];
  lsPriceLabelSectionAvailable: PriceLabelSection[];
  lsBarCodeType: CatalogDet[];
  showLabel = false;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _catDetFacede: CatalogDetFacade,
    private _priceLabelSectionFacade: PriceLabelSectionFacade,
    private _priceLabelFacade: PriceLabelFacade,
    public strings: Strings,
    private _router: Router
  ) {
    this._storage.set('moduleUrl', this._router.url);
   }

  ngOnInit(): void {
    this.strings.init();    
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.language = 0;
    if (!this.isSpanish) {
        this.language = 1;
    }
    this.getTenant();
  }
  
  saveLabel() {
    if (this.validatePriceLabelInfo()) {
      let priceLabel = this.getPriceLabel();
      this.loading = true;
      
      this._priceLabelFacade.PostPriceLabel(priceLabel).subscribe(result => {
        this.loading = false;
        if (result.completed) {
          if (result.data > 0) {
            this.addAlert('<strong>' + this.strings.GetText( res.PriceLabelSuccessfully ) + '</strong>', 'success');
          } else {
            this.addAlert('<strong>' + this.strings.GetText( res.ErrorSavingTryAgain ) + '</strong>', 'danger');
          }
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger');
        return;
      });
    }
  }

  getPriceLabel(): PriceLabel {
    const plabel = new PriceLabel();
    plabel.priceLabelId = 0;
    plabel.organizationId = this.cmb_organization;
    plabel.catDetTypePriceId = this.cmb_priceType;
    plabel.catDetPrinterTypeId = 0;
    // generate label
    plabel.label = this.getGenerateLabel();
    plabel.active = true;
    plabel.createdDate = new Date();
    plabel.lastDateUpdate = new Date();
    plabel.catDetBarcodeTypeId = this.cmb_barcodeType;
    plabel.percentDiscount = this.percentDiscount;
    plabel.detail = this.getDetailInfo();
    return plabel;
  }

  getDetailInfo(): PriceLabelDet[] {
    const detail: PriceLabelDet[] = [];
  
    const sections = [this.cmb_PriceLabelSectionA1, this.cmb_PriceLabelSectionA2, this.cmb_PriceLabelSectionB1];
  
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
  
      if (section > 0) {
        detail.push({
          priceLabelId: 0,
          positionCode: i < 2 ? `A${i+1}` : 'B1',
          priceLabelSecId: section
        });
      }
    }
  
    return detail;
  }

  validatePriceLabelInfo(): boolean {
    if (this.cmb_organization == undefined || this.cmb_organization == '-1') {
      this.addAlert('<strong>' + this.strings.GetText(res.SelectOrganization) + '</strong>', 'danger');
      return false;
    } 
    if (this.cmb_priceType == undefined || this.cmb_priceType < 1) {
      this.addAlert('<strong>' + this.strings.GetText(res.SelectLabelType) + '</strong>', 'danger');
      return false;
    }
    if (this.cmb_barcodeType == undefined || this.cmb_barcodeType < 1) {
      this.addAlert('<strong>' + this.strings.GetText(res.SelectBarcodeType) + '</strong>', 'danger');
      return false;
    } 
    if (this.aditionalRow && (this.cmb_PriceLabelSectionB1 == undefined || this.cmb_PriceLabelSectionB1 < 1)) {
      this.addAlert('<strong>' + this.strings.GetText(res.SelectAditionalRow) + '</strong>', 'danger');
      return false;
    }

    return true;
  }

  getTenant() {
    this.loading = true;
    this.tenantId = this.strings.getTenant();
    if (this.tenantId < 0) {
      this.addAlert('<strong>' + this.strings.GetText(res.CouldNotGetTenant) + '</strong>', 'danger');      
    } 
    else {
      this.getOrganizationList();
    }
    this.loading = false;
  }

  getOrganizationList() {
    this.loading = true;
    this.lsOrganization = this.strings.getAvailableOrganizations().filter(x => x.tenantId == this.tenantId, Organization);
    if ( this.lsOrganization.length > 0) {
      this.loading = false;
      this.getPriceLabelSection();
    } else {
      this.loading = false;
      this.addAlert('<strong>' + this.strings.GetText(res.AlertOrganizationsCouldNotBeObtained) + '</strong>', 'danger');
    }
  }

  getPriceLabelSection() {
    this.loading = true;
    this._priceLabelSectionFacade.GetAll().subscribe(result => {
      this.loading = false;
      if (result.completed) {
        if (result.data != null) {
          this.lsPriceLabelSectionAvailable = result.data;
        }
      }
      this.getTypePriceList();
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      return;
    });
  }

  getBarCodeType() {
    this.loading = true;
    this._catDetFacede.Get(CatalogDetInfo.CatDetBarCodeType).subscribe(result => {
      this.loading = false;
      if (result.completed) {
        if (result.data != null) {
          this.cmb_barcodeType = -1;
          this.lsBarCodeType = result.data;
        }
      }
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      return;
    });
  }
  
  getTypePriceList() {
    this.loading = true;
    this._catDetFacede.Get(CatalogInfo.CatDetPriceType, this.language).subscribe(result => {
      this.loading = false;
      if (result.completed) {
        this.lsPriceType = result.data;
      }
      this.getBarCodeType();
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      return;
    });
  }

  // añadir alert
  addAlert(message: String, type: String): void {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  onChangeOrganization(){
    if (this.cmb_organization != '-1') {
      this.lsPriceLabelSectionA1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization, PriceLabelSection);
      this.lsPriceLabelSectionA2 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization, PriceLabelSection);
      this.lsPriceLabelSectionB1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization, PriceLabelSection);
      this.loadLabel();
    } 
    else {  
      this.lsPriceLabelSectionA1 = [];
      this.lsPriceLabelSectionA2 = [];
      this.lsPriceLabelSectionB1 = [];
      this.loadLabel();
    }
  }

  loadLabel() {
    if (this.cmb_organization != '-1' && this.cmb_priceType != -1) {
      this.loading = true;
      this._priceLabelFacade.GetByTypeActive(this.cmb_organization, this.cmb_priceType, CatalogDetInfo.CatDetPrinterTSC).subscribe(result => {
        this.loading = false;
        if (result.completed) {
          if (result.data != null) {
            
            this.percentDiscount = result.data.percentDiscount;
            var A1 = result.data.detail.find(x => x.positionCode == "A1");
            var A2 = result.data.detail.find(x => x.positionCode == "A2");
            var B1 = result.data.detail.find(x => x.positionCode == "B1");

            A1 = A1 == null ? new PriceLabelDet : A1;
            A2 = A2 == null ? new PriceLabelDet : A2;
            B1 = B1 == null ? new PriceLabelDet : B1;

            this.cmb_PriceLabelSectionA1 = A1.priceLabelSecId;
            this.cmb_PriceLabelSectionA2 = A2.priceLabelSecId;
            if (B1.priceLabelSecId > 0) {
              this.aditionalRow = true;
              this.cmb_PriceLabelSectionB1 = B1.priceLabelSecId;
            }
            else {
              this.aditionalRow = false;
            }
            this.cmb_barcodeType = result.data.catDetBarcodeTypeId;
            this.onChangePriceLabelSection();
            this.onChangeBarcodeType();

            this.showLabel = true;
          }
          else {
            this.aditionalRow = false;
            this.percentDiscount = false;
            this.showLabel = true;
            this.cmb_PriceLabelSectionA1 = -1;
            this.cmb_PriceLabelSectionA2 = -1;
            this.cmb_PriceLabelSectionB1 = -1;
            this.cmb_barcodeType = -1;
          }
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger');
        return;
      });
    }
    else {
      this.showLabel = false;
    }
  }

  onChangeBarcodeType() {
    if ( this.cmb_barcodeType == CatalogDetInfo.CatDetSKU) {
      this.barcodeExample = this.strings.GetText(res.SkuExampleCode)
    } else if ( this.cmb_barcodeType ==  CatalogDetInfo.CatDetUPC){
      this.barcodeExample = this.strings.GetText(res.UPCExampleCode)
    } else if ( this.cmb_barcodeType == CatalogDetInfo.CatDetEAN) {
      this.barcodeExample = this.strings.GetText(res.EANExampleCode)
    } else {
        this.cmb_barcodeType = -1;
        this.barcodeExample = '';
    }
  }
  
  onChangePriceLabelSection() {
    if (this.cmb_PriceLabelSectionA1 > 0) {
      this.lsPriceLabelSectionA2 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA1);
    }
    
    if (this.cmb_PriceLabelSectionB1 > 0) {
      this.lsPriceLabelSectionA2 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionB1);
    }

    if (this.cmb_PriceLabelSectionA1 > 0 && this.cmb_PriceLabelSectionB1 > 0) {
      this.lsPriceLabelSectionA2 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA1 && x.priceLabelSecId != this.cmb_PriceLabelSectionB1);
    }

    if (this.cmb_PriceLabelSectionA1 < 0 && this.cmb_PriceLabelSectionB1 < 0) {
      this.lsPriceLabelSectionA2 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization);
    } 

    if (this.cmb_PriceLabelSectionA2 > 0) {
      this.lsPriceLabelSectionA1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA2);
    } 
    
    if (this.cmb_PriceLabelSectionB1 > 0) {
      this.lsPriceLabelSectionA1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionB1);
    }

    if (this.cmb_PriceLabelSectionA2 > 0 && this.cmb_PriceLabelSectionB1 > 0) {
      this.lsPriceLabelSectionA1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA2 && x.priceLabelSecId != this.cmb_PriceLabelSectionB1);
    }

    if (this.cmb_PriceLabelSectionA2 < 0 && this.cmb_PriceLabelSectionB1 < 0) {
      this.lsPriceLabelSectionA1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization);
    } 

    if (this.cmb_PriceLabelSectionA2 > 0) {
      this.lsPriceLabelSectionB1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA2);
    } 
    
    if (this.cmb_PriceLabelSectionA1 > 0) {
      this.lsPriceLabelSectionB1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA1);
    }

    if (this.cmb_PriceLabelSectionA1 > 0 && this.cmb_PriceLabelSectionA2 > 0) {
      this.lsPriceLabelSectionB1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization && x.priceLabelSecId != this.cmb_PriceLabelSectionA1 && x.priceLabelSecId != this.cmb_PriceLabelSectionA2);
    }

    if (this.cmb_PriceLabelSectionA2 < 0 && this.cmb_PriceLabelSectionA1 < 0) {
      this.lsPriceLabelSectionB1 = this.lsPriceLabelSectionAvailable.filter(x => x.organizationId == this.cmb_organization);
    }
  }

  onChangeAditionalRow() {
    if (!this.aditionalRow) {
      this.lsPriceLabelSectionB1 = [];
      this.cmb_PriceLabelSectionB1 = -1;
    }
    this.onChangePriceLabelSection()
  }

  onChangePercentDiscount() {
    this.percentDiscount = false;

    if (this.cmb_priceType == CatalogDetInfo.CatDetOriginalPrice) {
      this.isBasePrice = true;
    } 
    else {
      this.isBasePrice = false;
    }
    this.loadLabel();
  }

  getGenerateLabel(): string {
    let textA1 = '';
    let textA2 = '';
    let textB1 = '';
    // Encontrar los elementos de lsPriceLabelSection1 que cumplen las condiciones y obtener sus ExampleValue
    const A1 = this.lsPriceLabelSectionA1.find(section => this.cmb_PriceLabelSectionA1 > 0 && section.priceLabelSecId == this.cmb_PriceLabelSectionA1);
    if (A1 != undefined) {
      textA1 = A1.propertyMatch
    } else {
      textA1 = ''
    }
    // Encontrar los elementos de lsPriceLabelSection2 que cumplen las condiciones y obtener sus ExampleValue
    const A2 = this.lsPriceLabelSectionA2.find(section => this.cmb_PriceLabelSectionA2 > 0 && section.priceLabelSecId == this.cmb_PriceLabelSectionA2);
    if (A2 != undefined) {
      textA2 = A2.propertyMatch
    } else {
      textA2 = ''
    }
    // Encontrar los elementos de lsPriceLabelSection3 que cumplen las condiciones y obtener sus ExampleValue
    const B1 = this.lsPriceLabelSectionB1.find(section => this.cmb_PriceLabelSectionB1 > 0 && section.priceLabelSecId == this.cmb_PriceLabelSectionB1);
    if (B1 != undefined) {
      textB1 = B1.propertyMatch
    } else {
      textB1 = ''
    }

    // Concatenar las cadenas de texto en el formato especificado
    const result = `${textA1 != undefined ? 'A1:' + textA1 : ''}${textA2 != undefined ? ',A2:' + textA2 : ''}${textB1 != undefined ? ',B1:' + textB1 : ''}`;

    // La variable "result" contendrá la cadena de texto formada con el formato especificado
    return result;
  }
  
}


